class CreditEarlyRepaymentChange {
    constructor(key, date, value, currency){
        this.key = key;
        this.date = date;
        this.value = value;
        this.currency = currency;
    }
}

export default CreditEarlyRepaymentChange;